import * as RadixDialog from '@radix-ui/react-dialog';
import React from 'react';

import { cn } from '@/lib/utils/tailwind';

type DialogOverlayProps = Omit<
  RadixDialog.DialogOverlayProps,
  'asChild' | 'color'
> & {
  className?: string;
  allowCloseOnClick?: boolean;
};

const DialogOverlay = ({
  className,
  allowCloseOnClick = true,
  ...props
}: DialogOverlayProps) => (
  <RadixDialog.Overlay
    className={cn('fixed inset-0 z-40 bg-neutral-1000/40', className)}
    onPointerDown={!allowCloseOnClick ? e => e.stopPropagation() : undefined}
    {...props}
  />
);

export { DialogOverlay, type DialogOverlayProps };
